(function () {
  'use strict';

  var colorIdx = (typeof window.felrioColorIdx !== 'undefined') ? window.felrioColorIdx : -1;
  var galleryId = window.felrioGalleryId || '';
  var gallery = galleryId ? document.getElementById(galleryId) : null;

  if (!gallery) return; // bail if page has no product gallery

  var variants = window.felrioProductVariants || [];

  function isMock(alt) {
    return (alt || '').toLowerCase().indexOf('mock') !== -1;
  }

  function getSwiperInstance(customEl) {
    if (!customEl) return null;
    if (customEl.instance) return customEl.instance;
    var c = customEl.querySelector('[class*="swiper--"]');
    return (c && c.swiper) || null;
  }

  function getColorFromVariantId(variantId) {
    if (colorIdx === -1) return '';
    var id = parseInt(variantId, 10);
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === id) {
        var opts = variants[i].opts;
        return (opts && opts[colorIdx]) || '';
      }
    }
    return '';
  }

  function getVariantIdFromUrl(url) {
    try { return new URL(url, location.href).searchParams.get('variant'); }
    catch (e) { return null; }
  }

  function shouldShow(alt, lc, hasMatch) {
    if (!lc || !hasMatch || !alt) return true;
    return alt.indexOf(lc) !== -1;
  }

  function hasColorMatch(elements, lc) {
    if (!lc) return false;
    for (var i = 0; i < elements.length; i++) {
      var a = (elements[i].getAttribute('data-media-alt') || '').toLowerCase();
      if (!isMock(a) && a && a.indexOf(lc) !== -1) return true;
    }
    return false;
  }

  // Patch Swiper's internal position grid so it matches the CSS layout
  // after some slides are hidden with display:none.
  // Without this, Swiper still thinks hidden slides occupy space → slideTo goes to wrong position.
  function patchSwiperGrid(swiper, slides, visArray) {
    if (!swiper || !swiper.params) return;

    var cSize = swiper.size; // container width
    // Fallback: read directly from DOM when Swiper hasn't computed size yet (common on mobile)
    if (!cSize && swiper.el) {
      cSize = swiper.el.offsetWidth || swiper.el.clientWidth;
    }
    if (!cSize) return;

    var perView = swiper.params.slidesPerView;
    var spBetween = swiper.params.spaceBetween || 0;

    var slideSize;
    if (perView === 'auto') {
      // 'auto' mode: Swiper reads getComputedStyle, display:none → 0px.
      // Just call update() and let Swiper handle it.
      swiper.update();
      return;
    } else {
      // Fixed slidesPerView: all slides are the same calculated size
      var perViewNum = parseFloat(perView) || 1;
      slideSize = (cSize - spBetween * (perViewNum - 1)) / perViewNum;
    }

    var grid = [];
    var sizes = [];
    var pos = 0;
    var maxVisPos = 0;

    for (var i = 0; i < slides.length; i++) {
      if (visArray[i]) {
        grid.push(pos);
        maxVisPos = pos;
        sizes.push(slideSize);
        pos += slideSize + spBetween;
      } else {
        // Hidden slide: map to last visible position so slideTo(hiddenIdx) stays on content
        grid.push(maxVisPos);
        sizes.push(0);
      }
    }

    swiper.slidesGrid = grid;
    swiper.slidesSizesGrid = sizes;
    // snapGrid must mirror slidesGrid (cover ALL slide DOM indices).
    // Swiper's touch-end handler computes stopIndex from slidesGrid (a DOM index,
    // e.g. 4) then calls slideTo(stopIndex+1 = 5). If snapGrid only has entries for
    // visible slides (e.g. [0,375,750]), slideTo(5) reads snapGrid[5]=undefined →
    // clamps to last → wrong image. With snapGrid = slidesGrid every DOM index maps
    // to the correct physical position.
    swiper.snapGrid = grid.slice();
    swiper.virtualSize = Math.max(0, pos - spBetween);
  }

  function filterByColor(color) {
    // Re-query gallery each time: the theme swaps section HTML on variant change via AJAX,
    // detaching the original element. Re-querying always targets the live DOM element.
    gallery = galleryId ? document.getElementById(galleryId) : null;
    if (!gallery) return;

    var lc = (color || '').toLowerCase().trim();

    var gridItems  = Array.from(gallery.querySelectorAll('.main-product__media--grid-item[data-media-alt]'));
    var sliderEl   = gallery.querySelector('.main-product__media--slider-wrapper swiper-product-gallery');
    var sliderSlides = Array.from(gallery.querySelectorAll('.main-product__media--slider-wrapper .swiper-slide[data-media-alt]'));
    var thumbsEl   = gallery.querySelector('swiper-product-thumbs');
    var thumbSlides = Array.from(gallery.querySelectorAll('.main-product__media--thumbs-wrapper .swiper-slide[data-media-alt]'));

    var gridMatch   = hasColorMatch(gridItems, lc);
    var sliderMatch = hasColorMatch(sliderSlides, lc);
    var thumbMatch  = hasColorMatch(thumbSlides, lc);

    // ── Desktop grid: plain CSS grid, display:none works fine ──
    gridItems.forEach(function (el) {
      var alt = (el.getAttribute('data-media-alt') || '').toLowerCase();
      el.style.display = shouldShow(alt, lc, gridMatch) ? '' : 'none';
    });

    // ── Thumbnails: visibility:hidden preserves Swiper index alignment ──
    thumbSlides.forEach(function (el) {
      var alt = (el.getAttribute('data-media-alt') || '').toLowerCase();
      var show = shouldShow(alt, lc, thumbMatch);
      el.style.visibility   = show ? '' : 'hidden';
      el.style.pointerEvents = show ? '' : 'none';
    });

    // ── Mobile slider: hide slides AND patch Swiper's position grid ──
    var sliderVis = sliderSlides.map(function (el) {
      var alt = (el.getAttribute('data-media-alt') || '').toLowerCase();
      return shouldShow(alt, lc, sliderMatch);
    });

    sliderSlides.forEach(function (el, i) {
      el.style.display = sliderVis[i] ? '' : 'none';
    });

    var swiper = getSwiperInstance(sliderEl);
    if (swiper) {
      // Store filter state so the patch survives Swiper resize (device rotation)
      swiper._felrioSlides = sliderSlides;
      swiper._felrioVis    = sliderVis;

      if (!swiper._felrioResizeHooked) {
        swiper._felrioResizeHooked = true;
        swiper.on('resize', function () {
          if (swiper._felrioSlides && swiper._felrioVis) {
            patchSwiperGrid(swiper, swiper._felrioSlides, swiper._felrioVis);
          }
        });
      }

      // One-time hook: intercept the gallery element's setActiveMedia so that
      // the theme's product-variants.js call (slideTo(rawDOMIndex)) is remapped
      // through our patched snapGrid. Without this the theme fires setActiveMedia
      // AFTER our filterByColor, overriding our slideTo(0) with the wrong index.
      if (sliderEl && !sliderEl._felrioSAMHooked) {
        sliderEl._felrioSAMHooked = true;
        var _origSAM = sliderEl.setActiveMedia;
        sliderEl.setActiveMedia = function (id) {
          var _sw = this.instance;
          if (!_sw || !_sw._felrioVis) {
            return typeof _origSAM === 'function' ? _origSAM.call(this, id) : undefined;
          }
          // Always show first image of the selected color (filterByColor already hid others)
          if (typeof _sw.slideTo === 'function' && this.dataset.hideOtherVariantsMedia === 'false') {
            _sw.slideTo(0, 0);
          }
        };
      }

      // Force Swiper to recalculate container size before patching (fixes swiper.size=0 on mobile)
      swiper.update();
      // Patch the grid so slideTo() uses positions that match the CSS flex layout
      patchSwiperGrid(swiper, sliderSlides, sliderVis);

      // Navigate to first visible slide (snapGrid[0] after patching = first visible position)
      var hasVisible = sliderVis.some(function (v) { return v; });
      if (hasVisible) swiper.slideTo(0, 0);
    }

    // Update thumbs swiper layout
    var thumbsSwiper = getSwiperInstance(thumbsEl);
    if (thumbsSwiper) thumbsSwiper.update();

    // Update product page title with selected color
    var h1 = document.querySelector('h1[data-base-title]');
    if (h1) {
      var baseTitle = h1.getAttribute('data-base-title');
      h1.textContent = (lc && color) ? baseTitle + ' - ' + color : baseTitle;
    }
  }

  function onVariantId(variantId) {
    if (!variantId) return;
    filterByColor(getColorFromVariantId(variantId));
  }

  function onUrlChange(url) {
    var variantId = getVariantIdFromUrl(url || location.href);
    if (variantId) onVariantId(variantId);
  }

  // ── 1. pushState / replaceState ──
  var origPush = history.pushState;
  history.pushState = function (state, title, url) {
    origPush.apply(history, arguments);
    if (url) onUrlChange(String(url));
  };
  var origReplace = history.replaceState;
  history.replaceState = function (state, title, url) {
    origReplace.apply(history, arguments);
    if (url) onUrlChange(String(url));
  };
  window.addEventListener('popstate', function () { onUrlChange(location.href); });

  // ── 2. Common Shopify theme variant events ──
  ['variant:change', 'variant:changed', 'product:variant:change',
   'theme:variant:change', 'variantChange'].forEach(function (name) {
    document.addEventListener(name, function (e) {
      var d = e.detail;
      if (!d) return;
      var v = d.variant || d;
      if (v && v.id) onVariantId(v.id);
      else if (d.url) onUrlChange(d.url);
    });
  });

  // ── 3. Theme swatch click (.button--variant uses click, not change) ──
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.button--variant');
    if (!btn) return;
    var input = btn.querySelector('input[type="radio"]');
    if (!input || !input.closest('[data-main-product]')) return;
    setTimeout(function () {
      var productEl = input.closest('[data-main-product]');
      if (!productEl) return;
      var groups = Array.from(productEl.querySelectorAll('.js-product-card-options'));
      if (colorIdx >= 0 && colorIdx < groups.length) {
        var checked = groups[colorIdx].querySelector('input[type="radio"]:checked');
        if (checked) filterByColor(checked.value);
      }
    }, 0);
  }, true);

  // ── 4. Fallback: native change on option inputs ──
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || (input.tagName !== 'INPUT' && input.tagName !== 'SELECT')) return;
    if (!input.closest('[data-main-product]')) return;
    var pos = parseInt(input.getAttribute('data-option-position'), 10);
    if (!isNaN(pos) && pos - 1 === colorIdx) { filterByColor(input.value); return; }
    var wrapper = input.closest('[data-option-name]');
    if (wrapper) {
      var wn = (wrapper.getAttribute('data-option-name') || '').toLowerCase();
      if (wn === 'color' || wn === 'colour') { filterByColor(input.value); return; }
    }
    var iname = (input.getAttribute('name') || '').toLowerCase();
    if (iname === 'color' || iname === 'colour' ||
        iname === 'options[color]' || iname === 'options[colour]') {
      filterByColor(input.value);
    }
  });

  // ── 5. Initial load ──
  // Retry until Swiper is initialised (slow mobile devices may need > 300ms)
  var _initAttempts = 0;
  function _tryInitFilter() {
    gallery = galleryId ? document.getElementById(galleryId) : null;
    if (!gallery) { _initAttempts++; if (_initAttempts < 15) setTimeout(_tryInitFilter, 200); return; }
    var sliderEl = gallery.querySelector('.main-product__media--slider-wrapper swiper-product-gallery');
    var swiper   = getSwiperInstance(sliderEl);
    if (!swiper && _initAttempts < 15) {
      _initAttempts++;
      setTimeout(_tryInitFilter, 200);
      return;
    }
    var savedY = window.pageYOffset;
    filterByColor(window.felrioInitialColor || '');
    // Remove pending state now that filtering is done (prevents flash of all-color images)
    gallery.removeAttribute('data-felrio-pending');
    window.scrollTo(0, savedY);
  }
  setTimeout(_tryInitFilter, 200);

})();
